import * as React from "react"
import Svg, { Path } from "react-native-svg"

const EyeIcon = (props) => (
    <Svg
        width={20}
        height={20}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M19.72 10.467a.867.867 0 0 0 0-.934c-.976-1.546-4.464-6.408-9.72-6.408S1.256 7.987.28 9.533a.868.868 0 0 0 0 .934c.976 1.546 4.464 6.408 9.72 6.408s8.744-4.862 9.72-6.408Zm-17.881.075a.93.93 0 0 1 0-1.084A16.416 16.416 0 0 1 3.54 7.446C5.15 5.835 7.35 4.375 10 4.375c2.65 0 4.849 1.46 6.46 3.071.673.677 1.286 1.411 1.831 2.194a.63.63 0 0 1 0 .72c-.419.6-1.037 1.4-1.831 2.194-1.611 1.611-3.811 3.071-6.46 3.071-2.65 0-4.849-1.46-6.46-3.071a16.388 16.388 0 0 1-1.701-2.012Z"
            fill="#fff"
        />
        <Path
            d="M10 6.875a3.125 3.125 0 1 0 0 6.25 3.125 3.125 0 0 0 0-6.25ZM5.625 10a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0Z"
            fill="#fff"
        />
    </Svg>
)

export default EyeIcon
